import { AwardVisibility, BudgetPeriod } from '../../entities/awards';
import { GroupType } from '../../entities/groups';
import { User } from '../../entities/users';

export enum BudgetMode {
	FlexibleLimit = 'flexible',
	FixedLimit = 'fixed',
	NoLimit = 'none',
}

export enum MessageMode {
	Custom = 'custom',
	Provided = 'provided',
	Editable = 'editable',
}

export type AwardFormData = {
	name: string;
	description: string;
	conditions: { attr: string | undefined; value: string | undefined }[];
	conditionsOperator: GroupType;
	budgetMode: BudgetMode;
	budgetPerPeriod: number | null;
	periodType: BudgetPeriod;
	amount: number | null;
	amountEditable: boolean;
	icon: File | string | null;
	title: string;
	messageMode: MessageMode;
	message: string;
	visibility: AwardVisibility;
	visibilityEditable: boolean;
	requireApproval: boolean;
	approvalLevels: User[][];
};
